import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class Auth0AuthenticationService {
    constructor(private http: HttpClient) {}
    
    url: string = `https://${environment.auth0.domain}`;
    
    signup(data: any) {
        data.client_id = environment.auth0.clientId;
        data.connection = 'Username-Password-Authentication';

        return this.http.post(`${this.url}/dbconnections/signup`, data);
    }

    getToken() {
        return this.http.post(`${this.url}/oauth/token`, environment.auth0LogicalApi);
    }
}